import DocumentRepository from "../Repository/DocumentRepository";
import RemoveCompleteDownload from "../UseCase/RemoveCompleteDownload";
import DownloadManagerRepository from "../Repository/DownloadManagerRepository";
import ResourceRepository from "../Repository/ResourceRepository";
import DocumentResourceRepository from "../Repository/DocumentResourceRepository";
import getDatabase from "./database";

const removeCompleteDownload: RemoveCompleteDownload = new RemoveCompleteDownload(
    new DocumentRepository(getDatabase()),
    new DownloadManagerRepository(getDatabase()),
    new ResourceRepository(getDatabase()),
    new DocumentResourceRepository(getDatabase())
);

export default function getRemoveCompleteDownload(): RemoveCompleteDownload {
    return removeCompleteDownload;
};